import React from 'react';
import { STYLES } from '../../designSystem';

export default function Card({ children, style, fullWidth = false }) {
  const cardStyle = {
    ...STYLES.card,
    ...(fullWidth ? { maxWidth: '1400px', margin: '0 auto 20px' } : {}),
    ...style,
  };

  return <div style={cardStyle}>{children}</div>;
}
